import React from 'react';
import MediaUrlProcessor from './MediaUrlProcessor';
import type { MediaUrlProcessorProps } from './MediaUrlProcessor/types';

// Keep the original interface for backward compatibility
interface EmbedLinkProps {
	Embednote: string;
	fileType: string;
	onFileSelect?: (url: string, source: string, key?: string) => void;
	onClose?: () => void;
	companyId?: string;
	fromCreation?: string;
}

const EmbedLink = ({
	Embednote,
	fileType,
	onFileSelect,
	onClose,
	companyId,
	fromCreation
}: EmbedLinkProps): React.ReactElement =>
{
	// Map the old props to the new component props
	// Handle audio fileType mapping to podcast for MediaUrlProcessor
	// Normalize fileType to lowercase to handle case variations
	const normalizedFileType = fileType.toLowerCase();
	const mappedFileType = normalizedFileType === 'audio' ? 'podcast' : normalizedFileType;

	const mediaUrlProcessorProps: MediaUrlProcessorProps = {
		Embednote,
		fileType : mappedFileType as 'video' | 'image' | 'document' | 'podcast',
		onFileSelect,
		onClose,
		companyId,
		fromCreation
	};

	return <MediaUrlProcessor {...mediaUrlProcessorProps} />;
};

export default EmbedLink;